import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { lenisRef } from "@/lib/smooth";

// Botón lateral para regresar al inicio; aparece al bajar por la página
export const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.button
          key="back-to-top"
          type="button"
          data-testid="back-to-top-btn"
          aria-label="Regresar al inicio"
          onClick={goTop}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          className="group fixed bottom-5 left-5 z-[60] flex items-center gap-2 rounded-full border border-gold/50 bg-espresso/80 p-3.5 text-gold shadow-lg backdrop-blur-md transition-colors hover:bg-gold hover:text-espresso md:bottom-8 md:left-8"
        >
          <ArrowUp size={20} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
          <span className="hidden pr-1 font-sans text-xs uppercase tracking-[0.2em] md:inline">Inicio</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
